import { useEffect, useMemo, useState } from "react";
import { TreeItem } from "../types";
import { getItemsIds } from "../utils";

export const useExpandTree = (items: TreeItem[]) => {
  const [ready, setIsReady] = useState(false);
  const [expanded, setExpanded] = useState<string[]>([]);

  const allIds = useMemo(() => {
    return getItemsIds(items);
  }, [items]);

  const toggle = (itemId: string, isExpanded: boolean) => {
    setExpanded((prev) =>
      isExpanded ? [...prev, itemId] : prev.filter((id) => id !== itemId)
    );
  };

  useEffect(() => {
    if (allIds.length === 0 || ready) return;

    setIsReady(true);
    setExpanded(allIds);
  }, [allIds, ready]);

  return {
    expanded,
    toggle,
    ready,
  };
};
